import React, { useEffect, useRef, useState } from 'react';
import styles from './style.scss';
import VideoPlayerWrapper from '../Video/VideoPlayerWrapper';
import Button from 'jd-library/Button';
import WalkThroughModal from './WalkthroughModal';
import historyHandler from 'jd-library/historyHandler';
import Axios from 'axios';
import { useSelector } from 'react-redux';

    const WalkThrough = props => {
        const [videoEnd,updateEnd] = useState(false);
        const [whiteBorder,toggleBorder] = useState(false);
        const [isPlaying,updateIsPlaying] = useState(false);
        const [showModal,toggleModal] = useState(true);
        const docId = useSelector(state => state.session.docId);
        const playerRef = useRef(null);

        let videoProps = {
                "imgIndex": 1696296784403,
                "isVideo": true,
                "walkthrough": true,
                "showMaxImagesToast": false,
                "noOfFilesToUpload": 1,
                "ignoreSave": true,
                "token": "QzRxaHF5WDYrV3NHZHRWRWl6dFhIMVZkcVBlSC9FRVYzWmd5bGFlcnpDMjRyVFNlbEV0b2ZLK0tLTjFxb1RhSA==",
                "imgURL": "/DC/BE/10/dcbe1036-a089-4418-9a59-a08b69dba9d1-1695724880312/dcbe1036-a089-4418-9a59-a08b69dba9d1-1695724880312.m3u8",
                "actualPath": "https://sourcestream.jdmagicbox.com/input/tutorial-denotszkyyvdegn-standard-walkthrough-video.mp4",
                "thumbnailURL": "/6C/69/F8/6c69f845-67ad-42f8-ba4e-479dad821c51-1695287582669/6c69f845-67ad-42f8-ba4e-479dad821c51-1695287582669.png",
                "originalPath": "/productB2B_video/MD/Mw/dcbe1036-a089-4418-9a59-a08b69dba9d1-1695724880312.mp4",
                "uploaded": true,
                "updateVideoId": true,
                "newVideoId": 2847,
                "videoId": "2847",
                "playing": true,
                "horizontal": true,
                "tabIndex": -1,
                "style": {
                    "width": "100%",
                    "display": "inline-block"
                }
        }


        const closeWalkthrough = (fromModal = false) => {
            Axios.get('/marketplace/omni-db-api/ajax/WalkThroughSetDocid?docId='+docId).then(res => {
                console.log(res.data.results.msg)
            }).catch(err => {
                console.log('Error in WalkThroughSetDocid : ',err);
            })
            fromModal && toggleModal(false);
            props.hideWalkthrough();
        }
        const replayVideo = () => {
            playerRef.current.seekTo(0);
            updateEnd(false);
            toggleBorder(false);
            playerRef.current.getInternalPlayer().play();
        }
        const playVideo = () => {
            document.querySelector('.react-player__preview').click();
            Axios.get('/marketplace/omni-db-api/ajax/WalkThroughSetDocid?docId='+docId).then(res => {
                console.log(res.data.results.msg)
            }).catch(err => {
                console.log('Error in WalkThroughSetDocid : ',err);
            })
        }

        const suppressSafariControls = () => {
            if (playerRef.current) {
              const videoElement = playerRef.current.getInternalPlayer();
              if(videoElement) {
                  videoElement.controls = false;
                  videoElement.addEventListener("webkitbeginfullscreen", () => {
                    videoElement.controls = false;
                  });
                  videoElement.addEventListener("webkitendfullscreen", () => {
                    videoElement.controls = false;
                  });
              }
            }
          };

          useEffect(() => {
            if(!showModal)
                suppressSafariControls()
          },[showModal])

        return (
            <div className={`${styles['walkthrough']} ${whiteBorder?styles['white-back']:''}`}>
                {showModal ? <WalkThroughModal onHidden={() => toggleModal(false)} skipClick={closeWalkthrough} watch={playVideo} /> : null}
                <div className={`${styles['walkthrough-player']} ${videoEnd?styles['end']:''} ${whiteBorder?styles['whiteBorder']:''}`}>
                    <VideoPlayerWrapper 
                        ref={playerRef} 
                        playerProps={{
                            onReady: () => {
                                setTimeout(() => {
                                    toggleBorder(true);
                                }, 20000);
                            },
                            onPlay: () => {
                                if(!isPlaying) {
                                    let playerEle = playerRef.current.getInternalPlayer();
                                    playerEle && typeof playerEle.exitFullscreen == 'function' && playerEle.exitFullscreen();
                                    updateIsPlaying(true);
                                }
                                historyHandler.closeCurrent();
                            },
                            onEnded: () => updateEnd(true),
                            muted: true,
                            config: { file: { attributes: { controlsList: 'nodownload' } } },
                            allowfullscreen: false,
                            playsinline: true
                        }}
                        {...videoProps}
                        autoPlay={true} />
                </div>
                {videoEnd ? 
                    <div className={styles['btn-holder']}>
                        <Button variant={'default'} className={`${styles['replay-btn']} btn`} onClick={replayVideo}>
                            Replay
                            <i className='icon-Replay' />
                        </Button>
                        <Button className={`btn ${styles['cntn-btn']}`} onClick={closeWalkthrough}>
                            Continue
                            <i className='icon-next' />
                        </Button>
                    </div> : null}
            </div>
        )
    };

    export default WalkThrough;